<template>
  <td :colspan="headers.length">
    <v-row cols="12" class="px-2 py-6">
      <v-col cols="2" class="pl-0 col-without-bottom-padding col-without-top-padding">
        <img src="@/assets/map.png">
      </v-col>
      <v-col cols="10" class="expand-trip-wrapper">
        <v-row>
          <v-col class="d-flex flex-column col-without-bottom-padding col-without-top-padding">
            <span class="detail-info-title text-uppercase my-2">{{ $t(`components.tripsHistory.expandInfo.vehicleClass`) }}</span>
            <span class="detail-info-value">{{ getVehicleInfo }}</span>
          </v-col>
          <v-divider class="expand-divider" vertical/>
          <v-col class="d-flex flex-column col-without-bottom-padding col-without-top-padding">
            <span class="detail-info-title text-uppercase my-2">{{ $t(`components.tripsHistory.expandInfo.tripId`) }}</span>
            <span class="detail-info-value">{{ data.dispatchId || `N/A` }}</span>
          </v-col>
          <v-divider class="expand-divider" vertical/>
          <v-col class="d-flex flex-column col-without-bottom-padding col-without-top-padding">
            <span class="detail-info-title text-uppercase my-2">{{ $t(`components.tripsHistory.expandInfo.created_by`) }}</span>
            <span class="detail-info-value">{{createdBy}}</span>
          </v-col>
        </v-row>
        <v-divider class="mt-6 expand-divider"/>
        <v-row v-if="hasAccess(CORP_ADMIN)" justify="space-between" class="align-center expand-actions-container mt-4" no-gutters>
          <v-col class="d-flex pb-1 justify-space-between col-without-bottom-padding col-without-top-padding">
            <v-btn outlined tile
                   v-if="completedBooking && hasAccess(CORP_ADMIN)"
                   class="expand-button expand-black"
                   :loading="receiptLoading"
                   @click="downloadReceipt(data.bookingId)"
            >{{ $t(`button.download-receipt`) }}</v-btn>
          </v-col>
          <v-col class="d-flex pb-1 flex-row-reverse col-without-bottom-padding col-without-top-padding">
            <v-btn outlined tile
              class="expand-button expand-black ml-2"
              @click="copyBooking(data.bookingId)">
              {{ $t(`button.reuse`) }}
            </v-btn>
            <v-btn
              v-if="data.trackmytaxi"
              :href="generateTMTLink(data.trackmytaxi)"
              target="_blank"
              outlined
              tile
              class="expand-button expand-black ml-2">
              {{ $t(`button.track`) }}
            </v-btn>
            <v-btn
              v-if="canCancelTrip"
              class="expand-button expand-white"
              outlined
              tile
              @click="openDialog('cancel-booking')"
            >{{ $t(`button.cancel`) }}</v-btn>
            <v-btn outlined tile
                   v-if="prebookedBooking === data.status"
                   class="expand-button expand-black mr-2"
                   @click="editBooking(data.bookingId)">
              {{ $t(`button.edit`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-wrapper ref="dialogComponent"/>
    <div id="receipt-element" class="d-none" v-html="receipt"></div>
  </td>
</template>

<script>
import { mapGetters } from 'vuex';
import html2pdf from 'html2pdf.js';
import slugify from 'slugify';
import { getRoles } from '@/mixins/authentication.mixins';
import { CHANNEL_ADMIN, CORP_ADMIN } from '@/helpers/userRoles';
import Status from '@/helpers/statusTypes';
import DialogWrapper from '@/components/elements/DialogWrapper.vue';

export default {
  name: 'expan-item',
  components: {
    DialogWrapper,
  },
  mixins: [getRoles],
  data() {
    return {
      CHANNEL_ADMIN,
      CORP_ADMIN,
      receipt: null,
      receiptLoading: false,
      prebookedBooking: Status.new[4],
    };
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    tab: {
      type: Array,
      required: true,
    },
  },
  methods: {
    openDialog(type) {
      this.$refs.dialogComponent.openDialog({ id: this.data.bookingId, type });
    },
    copyBooking(id) {
      this.$router.push({ name: 'booking-copy', params: { id } });
    },
    editBooking(id) {
      this.$router.push({ name: 'booking-edit', params: { id } });
    },
    hasAccess(role) {
      return this.userRoles ? this.userRoles.filter((userRole) => userRole.name === role).length > 0 : false;
    },
    generateTMTLink(href) {
      const lngArray = ['en', 'fr'];

      return `${href}?lng=${lngArray.includes(this.selectedLanguage) ? this.selectedLanguage : 'en'}`;
    },

    async downloadReceipt(bookingId) {
      this.receiptLoading = true;
      this.receipt = await this.$store.dispatch('tripsHistory/getBookingReceipt', bookingId);
      window.setTimeout(async () => {
        html2pdf(document.getElementById('receipt-element'), {
          margin: 1,
          filename: this.getFileName(),
        });
        this.receiptLoading = false;
      }, 3000);
    },
    getFileName() {
      return `${slugify(`receipt-${this.data.createdAt}`)}.pdf`;
    },
  },
  computed: {
    ...mapGetters({
      selectedLanguage: 'language/selectedLanguage',
    }),
    getVehicleInfo() {
      if (this.data.vehicle) {
        return `${this.data.vehicle.make} ${this.data.vehicle.model}`;
      }

      return 'N/A';
    },
    pastBooking() {
      return [
        ...Status.cancelled,
        ...Status.completed,
      ].includes(this.data.status);
    },
    completedBooking() {
      return [
        ...Status.completed,
      ].includes(this.data.status);
    },
    createdBy() {
      if (this.data.bookedByUserInfo) {
        return `${this.data.bookedByUserInfo.givenName} ${this.data.bookedByUserInfo.familyName}`;
      }
      return `${this.data.userInfo.givenName} ${this.data.userInfo.familyName}`;
    },
    canCancelTrip() {
      return ['NEW', 'ASSIGN', 'ENROUTE', 'PREBOOKED'].includes(this.data.status);
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  min-height: 115px;
  height: 100%;
}
.map-image {
  background-image: url('../../assets/map.png');
  background-size: auto 100%;
  height: 150px;
}
.detail-info-title {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #888888;
}
.detail-info-value {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.005em;
  color: #333333;
}

.expand-divider {
  background: #EEEEEE;
}

.expand-links {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: -0.005em;
  text-decoration-line: underline;
  color: #888888;
  cursor: pointer;
}

.expand-button {
  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 6px;

  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.005em;
}

.expand-button::before {
  background-color: transparent !important;
}
.expand-white {
  color: #333333;
  background: #FFFFFF;
}

.expand-black {
  background-color:#333333;
  color: #FFFFFF;
}

.expand-black:hover {
  background-color: #888888;
  border: 1px solid #888888;
}

.expand-white:hover {
  color: #888888;
  border: 1px solid #888888;
}
</style>
